import { useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  

  return (
    <section className="relative overflow-hidden bg-black py-20">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C8F135]/40 to-transparent" />

      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#C8F135]/10 border border-[#C8F135]/20 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-flashlight-line text-[#C8F135] text-sm" />
          <span className="text-[#C8F135] text-xs font-semibold uppercase tracking-wider">Get Started Today</span>
        </div>

        <h2 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
          Ready to Lead with AI?
        </h2>
        <p className="text-zinc-400 text-lg mb-10 max-w-xl mx-auto">
          Join 500+ organizations that trust CPI Technologies to turn AI strategy into real-world results.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg bg-[#C8F135] text-black font-bold text-base whitespace-nowrap cursor-pointer hover:bg-[#b5e000] transition-colors"
          >
            <i className="ri-calendar-check-line" /> Book a Free Consultation
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg border border-white/20 text-white font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-white/8 transition-colors"
          >
            Explore Our Services <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Contact info */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-zinc-400 mb-12">
          <a href="mailto:info@cpitechinc.com" className="flex items-center gap-2 hover:text-white transition-colors">
            <i className="ri-mail-line text-[#C8F135]" /> info@cpitechinc.com
          </a>
          <span className="hidden sm:block text-zinc-700">·</span>
          <a href="tel:+12242018888" className="flex items-center gap-2 hover:text-white transition-colors">
            <i className="ri-phone-line text-[#C8F135]" /> +1 (224) 201-8888
          </a>
          <span className="hidden sm:block text-zinc-700">·</span>
          <span className="flex items-center gap-2">
            <i className="ri-map-pin-line text-[#C8F135]" /> Chicago, IL &amp; Lagos, Nigeria
          </span>
        </div>

        
      </div>

      <div className="border-t border-white/5 mt-12 py-4 text-center">
        <p className="text-zinc-600 text-xs italic">
          &ldquo;Together, We Make AI Happen.&rdquo; CPI Technologies Inc. · Chicago &amp; Lagos · Founded 1996
        </p>
      </div>
    </section>
  );
}
